import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Element } from '../element';
import { useControlContext } from '../../form/control/context';
import * as styles from './icon.styles';

/**
 *
 * @type {typeof import('.').Icon}
 */
const Icon = forwardRef(({ name, className, as = 'i', invariant, children, isInteractive, ...props }, ref) => {
  const { disabled, ...rest } = useControlContext(props);

  return (
    <Element
      ref={ref}
      as={as}
      isInteractive={!!props.onClick || isInteractive}
      data-icon={!children ? name : undefined}
      className={clsx(styles.icon, className, {
        invariant,
        [styles.variants.interactive]: !!props.onClick || isInteractive,
      })}
      role="img"
      aria-label={name}
      disabled={disabled}
      {...rest}
    >
      {children}
    </Element>
  );
});

if (process.env.NODE_ENV !== 'production') {
  Icon.displayName = 'Icon';
}

export default Icon;
